import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { useTranslation } from "react-i18next";
import TextInput from '../../shared/Fields/TextInput';
import "react-client-captcha/dist/index.css"
import PasswordService from '../../services/forgotpassword'
import { supportMail } from '../../config';
import Footer from '../../shared/footer';
import GQLogoComponent from '../../shared/components/GQLogoComponent';
import ReplayIcon from '@material-ui/icons/Replay';


const Forgotpassword = () => {


    const [captchaUrl, setCaptchaUrl] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    function generateTimeBasedMD5() {
        return Date.now().toString();
    }

    const getCaptchaUrl = () => {
        return process.env.REACT_APP_BASE_URL +"/external_lib/securimage/securimage_show?sid=" + generateTimeBasedMD5();
    }

    useEffect(() =>{
        setCaptchaUrl(getCaptchaUrl())
    },[])

    const { t, i18n } = useTranslation('common');

    const [username, setUsername] = useState("");
    const [userCaptchaCode, setUserCaptchaCode] = useState("");

    const [recoveryResponse, setRecoveryResponse] = useState("");

    const submit = async ()=>{
   
        let data = {
            userid: username,
            code: userCaptchaCode,
        }

        const result = await PasswordService.forgotPassword(data);
 
        if (result.response_content.success === false) {

            if (result.response_content.errors[0] === 'locked' || result.response_content.errors[0] === 'ACCOUNT_EXPIRED') {
                setRecoveryResponse(result.response_content.errors[0])
            }

            if (result.response_content.errors[0] === 'Code does not match') {
                setErrorMsg(result.response_content.errors[0]);
                setCaptchaUrl(getCaptchaUrl())
            }

        }else{
            setRecoveryResponse("none")
        }
        
    }




    return (
        <div style={{width: "100%", display: "flex", justifyContent: "center", marginTop: "100px"}}> 
            <div style={{width: "500px"}}>
                <div>
                    <GQLogoComponent toLink='#/login' />
                </div>
                    
                <div style={{width: "100%", display: "flex", marginTop: "25px"}}>
                    <div style={{border: "2px solid #bfb4b4", padding: "15px 20px", borderRadius: "6px", width: "500px"}}>
                        {recoveryResponse === "" &&
                        <div>
                            <div>
                                <h5 className="loginTitle">{t('pwdRecovery')}</h5>
                                <p className="bodyText mb-4">{t('pwdRecoveryTitle')}</p>
                            </div> 
                            

                            <div style={{height: "33px"}}>
                            {errorMsg !== "" &&
                             <h6 className="loginFailedTitle">The code was incorrect, please try again</h6>
                            }
                            </div>

                            <div className="form-group">
                                <TextInput
                                    fullWidth
                                    id="userName"
                                    name="userName"
                                    label={t('userName')}
                                    variant="outlined"
                                    value={username}
                                    onChange={(e)=>{setUsername(e.target.value)}}
                                />
                            </div>
                            <div className="form-group">
                                <TextInput
                                    fullWidth
                                    id="captchaCode"
                                    name="captchaCode"
                                    label={t('codeShown')}
                                    variant="outlined"
                                    value={userCaptchaCode}
                                    onChange={(e)=>{setUserCaptchaCode(e.target.value)}}
                                />
                            </div>
                            <div>
                                <img src={captchaUrl} id="image"/> <ReplayIcon onClick={()=>{setCaptchaUrl(getCaptchaUrl())}} style={{color: "#337AB7", cursor:"pointer"}}></ReplayIcon>
                            </div>
                            <div>
                                {username !== "" && userCaptchaCode !== "" ?
                                    <Button variant="contained" disableRipple={true} className='accountInfo' onClick={()=>{submit()}}>{t('submit')}</Button> :
                                    <Button variant="contained" className='cancelButtonDisable' disableRipple={true}>{t('submit')}</Button>
                                }
                            </div>
                        </div>
                        }
                        {recoveryResponse === "none" &&
                        <div className={'p-4 d-block'}>

                            <h5>{t('pwdRecovery')}</h5>
                            <br />
                            <p>{t('thankYou')}</p>
                            <p>{t('loginInfoText')}</p>
                            <p>{t('pleaseContactText1')} <a href={"mailto:" + supportMail}>{supportMail}</a> {t('pleaseContactText2')}</p>
                        </div>
                        }

                        {recoveryResponse === "locked" &&
                        <div className={'p-4 d-block'}>

                            <h5>Password Recovery</h5>
                            <br />
                            <br />
                            <p>Too many unsuccessful attempts to access this account have been received. For your protection, the account has been locked.</p>
                            <p>Please contact <a href={"mailto:" + supportMail}>{supportMail}</a> for assistance.
                            </p>
                        </div>
                        }
                        {recoveryResponse === "ACCOUNT_EXPIRED" &&
                        <div className={'p-4 d-block'}>

                            <h5>Password Recovery</h5>
                            <br />
                            <br />
                            <p>{t('acctExpired')}</p>
                        </div>
                    }
                    </div>
                </div>
                <div>
                    <Footer />
                </div>
            </div>
        </div>
    );
}

export default Forgotpassword;
